'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from 'cn';
import { motion, useAnimate, useInView } from 'motion/react';
import { useTranslations } from 'next-intl';
import { useEffect, useRef } from 'react';
import { BlurImage } from '@/components/blur-image';
import { buttonVariants } from '../ui/button';
const variants = {
  initial: {
    y: 40,
    opacity: 0
  },
  animate: {
    y: 0,
    opacity: 1
  }
};
export function GetInTouch() {
  const $ = _c(33);
  const [scope, animate] = useAnimate();
  const cardsRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      once: true,
      margin: "-100px"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isInView = useInView(cardsRef, t0);
  const t = useTranslations();
  let t1;
  let t2;
  if ($[1] !== animate) {
    t1 = () => {
      animate([["#pointer", {
        left: 200,
        top: 60
      }, {
        duration: 0
      }], ["#javascript", {
        opacity: 1
      }, {
        duration: 0
      }], ["#pointer", {
        left: 50,
        top: 102
      }, {
        at: "+0.5",
        duration: 0.5,
        ease: "easeInOut"
      }], ["#javascript", {
        opacity: 0.4
      }, {
        at: "-0.3",
        duration: 0.1
      }], ["#react-js", {
        opacity: 1
      }, {
        duration: 0.3
      }], ["#pointer", {
        left: 224,
        top: 170
      }, {
        at: "+0.5",
        duration: 0.5,
        ease: "easeInOut"
      }], ["#react-js", {
        opacity: 0.4
      }, {
        at: "-0.3",
        duration: 0.1
      }], ["#typescript", {
        opacity: 1
      }, {
        duration: 0.3
      }], ["#pointer", {
        left: 88,
        top: 198
      }, {
        at: "+0.5",
        duration: 0.5,
        ease: "easeInOut"
      }], ["#typescript", {
        opacity: 0.4
      }, {
        at: "-0.3",
        duration: 0.1
      }], ["#next-js", {
        opacity: 1
      }, {
        duration: 0.3
      }], ["#pointer", {
        left: 200,
        top: 60
      }, {
        at: "+0.5",
        duration: 0.5,
        ease: "easeInOut"
      }], ["#next-js", {
        opacity: 0.4
      }, {
        at: "-0.3",
        duration: 0.1
      }], ["#javascript", {
        opacity: 1
      }, {
        duration: 0.3
      }]], {
        repeat: Number.POSITIVE_INFINITY
      });
    };
    t2 = [animate];
    $[1] = animate;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  const t3 = isInView ? "animate" : "initial";
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      duration: 0.5
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t("homepage.get-in-touch.image-alt");
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <BlurImage src="/images/avatar.png" width={1024} height={1024} className="absolute top-1/2 left-1/2 size-20 -translate-1/2 rounded-3xl" alt={t5} />;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t10;
  let t7;
  let t8;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div id="next-js" className="absolute bottom-12 left-14 rounded-4xl border bg-accent px-2 py-1.5 text-xs opacity-40">Next.js</div>;
    t8 = <div id="react-js" className="absolute top-20 left-2 rounded-4xl border bg-accent px-2 py-1.5 text-xs opacity-40">React.js</div>;
    t9 = <div id="typescript" className="absolute right-1 bottom-20 rounded-4xl border bg-accent px-2 py-1.5 text-xs opacity-40">TypeScript</div>;
    t10 = <div id="javascript" className="absolute top-10 right-8 rounded-4xl border bg-accent px-2 py-1.5 text-xs opacity-40">JavaScript</div>;
    $[9] = t10;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t10 = $[9];
    t7 = $[10];
    t8 = $[11];
    t9 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div id="pointer" className="absolute"><svg width="16.8" height="18.2" viewBox="0 0 12 13" className="fill-red-500" stroke="white" strokeWidth="1" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M12 5.50676L0 0L2.83818 13L6.30623 7.86537L12 5.50676V5.50676Z" /></svg><span className="relative left-4 rounded-4xl bg-red-500 px-2 py-0.5 text-xs text-white">Nelson</span></div>;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== scope || $[15] !== t6) {
    t12 = <div className="relative size-64 max-md:mx-auto" ref={scope}>{t6}{t7}{t8}{t9}{t10}{t11}</div>;
    $[14] = scope;
    $[15] = t6;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t) {
    t13 = t("homepage.get-in-touch.title");
    $[17] = t;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t13) {
    t14 = <p className="mb-2 text-3xl font-semibold">{t13}</p>;
    $[19] = t13;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t) {
    t15 = t("homepage.get-in-touch.description");
    $[21] = t;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t15) {
    t16 = <p className="text-muted-foreground">{t15}</p>;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="my-8"><a href="mailto:me@nelsonlai.dev" className={cn(buttonVariants(), "bg-email-button text-white")}>me@nelsonlai.dev</a></div>;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== t14 || $[27] !== t16) {
    t18 = <div className="flex flex-col justify-center px-4">{t14}{t16}{t17}</div>;
    $[26] = t14;
    $[27] = t16;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t12 || $[30] !== t18 || $[31] !== t3) {
    t19 = <motion.div className="relative flex flex-col justify-center gap-12 rounded-2xl p-5 shadow-feature-card md:flex-row" initial="initial" animate={t3} variants={variants} ref={cardsRef} transition={t4}>{t12}{t18}</motion.div>;
    $[29] = t12;
    $[30] = t18;
    $[31] = t3;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  return t19;
}